import React, { Component } from "react";

import {
  Modal,
  Text,
  BlockStack,
} from "@shopify/polaris";

import "./index.css";

//翻译包
import Language from '../../i18n/Language';
const t = Language

class DeleteModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingPage: true,
      modalActive: false,
      sheetActive: false,

      title: "",
      description: "",

      open: this.props.open,
      delSaveStatus: this.props.delSaveStatus,
      isRank: this.props.isRank,
    };
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.open !== this.props.open) {
      this.setState({
        open: nextProps.open
      })
    }

    if (nextProps.delSaveStatus !== this.props.delSaveStatus) {
      this.setState({
        delSaveStatus: nextProps.delSaveStatus
      })
    }

    return true;
  }

  //取消和关闭
  close = () => {
    this.props.CloseDeletePop(!this.props.open)
  }

  // 保存
  handleSaveAction = async () => {
    this.props.changeData(!this.props.open, this.props.deleteArr)
  }

  componentWillUnmount = async () => {
    this.setState = () => false
  }

  render() {
    const {
      state: { open, delSaveStatus, isRank },
      handleSaveAction,
      close,
    } = this;

    const pageContent = isRank ? <Modal
      size="small"
      open={open}
      onClose={close}
      title={t("Delete this keyword?")}
      primaryAction={[
        {
          content: t("Yes"),
          onAction: handleSaveAction,
          loading: delSaveStatus
        }
      ]}
      secondaryActions={[
        {
          content: t("Cancel"),
          onAction: close,
          disabled: delSaveStatus
        },
      ]}
    >
      <Modal.Section>
        <BlockStack>
          <Text variant="bodyLg" as="p" alignment="start">
            {t("After deleting this keyword, you will not be able to view the ranking of your page in the search results for this keyword.")}
          </Text>
        </BlockStack>
      </Modal.Section>
    </Modal> : <Modal
      size="small"
      open={open}
      onClose={close}
      title={t("Delete")}
      primaryAction={[
        {
          content: t("Delete"),
          onAction: handleSaveAction,
          loading: delSaveStatus
        }
      ]}
      secondaryActions={[
        {
          content: t("Cancel"),
          onAction: close,
          disabled: delSaveStatus
        },
      ]}
    >
      <Modal.Section>
        <BlockStack>
          <Text variant="bodyLg" as="p" alignment="start">
            {t("Are you sure you want to delete?")}
          </Text>
        </BlockStack>
      </Modal.Section>
    </Modal>;

    return (
      <div className="footerRating">
        <div className="footerRating_child">
          {pageContent}
        </div>
      </div>
    );
  }
}

export default DeleteModal;